import React from 'react';

export default function Loader() {
    return (
        <div className="text-center">
            <img
                src="/images/listing/createDocument/loader.gif"
                className="create-document-spinner"
                height="70px"
                alt="loader"
            />
        </div>
    )
}